export default __webpack_public_path__ + "static/media/vincennes8.038f5ff9.jpg";